import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import React from 'react';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';
import s from './StockIndicator.scss';

export const StockIndicatorDataHook = {
  LowStock: 'stock-indicator',
  OutOfStock: 'out-of-stock-indicator',
};

type StockIndicatorComponentProps = ProvidedGlobalProps & IProvidedTranslationProps;

const StockIndicatorComponent: React.FC<StockIndicatorComponentProps> = ({t, globals: {remainingItemCount}}) => {
  if (remainingItemCount > 0) {
    return (
      <ConditionalRender by="productPage_stockIndicator">
        <div className={s.stockIndicator} data-hook={StockIndicatorDataHook.LowStock}>
          {t('productPage.lowStockMessage.label', {Inventory: remainingItemCount})}
        </div>
      </ConditionalRender>
    );
  }

  if (remainingItemCount === 0) {
    return (
      <div className={s.outOfStockIndicator} data-hook={StockIndicatorDataHook.OutOfStock}>
        {t('PRODUCT_OUT_OF_STOCK_BUTTON')}
      </div>
    );
  }

  return null;
};

export const StockIndicator = withGlobalProps(withTranslations('globals.texts')(StockIndicatorComponent));
